angular.module('cfn').factory('cfnGridView', [
  'propertySupport',
  'cfnGridDefaults',
  function(propertySupport, cfnGridDefaults) {
    var service = {};

    service.init = function(scope, element, attrs) {
      var serviceInstance = {},
        isSortingDeactivatedOnce = false;

      scope.view = $.extend(false, cfnGridDefaults.defaults.view, {
        first: 0,
        amount: 0,
        filters: {},
        sorted: [],
        enumOptions: {}
      });

      scope.view.perPage = attrs.rowsperpage
        ? parseInt(attrs.rowsperpage)
        : scope.view.perPage;

      scope.view.perPageThreshold = attrs.rowsperpagethreshold
        ? parseInt(attrs.rowsperpagethreshold)
        : scope.view.perPageThreshold;

      scope.viewDataHash = {};

      scope.getPerPage = function(total) {
        if (
          total &&
          scope.view.perPageThreshold &&
          scope.view.perPageThreshold > total
        ) {
          return scope.view.perPageThreshold;
        }
        return scope.view.perPage;
      };

      scope.updateView = function(ds, afterFunc) {
        var sortedModel, filteredModel;

        if (scope.view.first >= scope.view.amount) {
          scope.view.first -= scope.view.amount;
          if (scope.view.first < 0) scope.view.first = 0;
        }

        if (!ds) {
          // if no datastore is used
          app.startPerfTimer('cfnGrid filter apply');

          app.stopPerfTimer('cfnGrid filter apply');
          app.startPerfTimer('cfnGrid sort');

          if (isSortingDeactivatedOnce) {
            sortedModel = scope.filterdData;
            isSortingDeactivatedOnce = false;
          } else {
            filteredModel = scope.$cfnGridFiltering.applyFilters(scope.ngModel);
            sortedModel = scope.$cfnGridSorting.applySort(filteredModel);
            sortedModel = scope.$cfnGridSelection.updateOrderBySelection(
              sortedModel
            );
          }

          app.stopPerfTimer('cfnGrid sort');

          app.startPerfTimer('cfnGrid model add');

          var viewData = serviceInstance.updatePaginationView(sortedModel);

          scope.filterdData = sortedModel;
          scope.view.loading = false;
          scope.$afterViewUpdate(viewData, afterFunc);
        } else {
          scope.view.loading = true;
          // the datastore functionality still is in development.
          ds.getData(scope.view, function(data, full_count) {
            scope.view.loading = false;
            scope.filterdData = data;
            if (!full_count) {
              full_count = 0;
            }
            scope.view.amount = full_count;

            scope.$afterViewUpdate(data, afterFunc);
          });
        }
      };

      // request a view update that is only done if nothing is changed for a given time
      scope.updateViewRequest = function() {
        if (scope.view.applyFilterImmediately) {
          scope.updateView(scope.datasource());
          scope.view.applyFilterImmediately = false;
        } else {
          ang.delayedTimeout(
            scope,
            '$updateViewRequest',
            function() {
              ang.apply(scope, function() {
                scope.updateView(scope.datasource());
              });
            },
            cfnGridDefaults.viewUpdateInterval
          );
        }
      };

      scope.changeViewPage = function(page, event) {
        // Since the page buttons are re-built in the DOM, the click event propagated and closed
        // popups somehow. To prevent this case, we stop bubbling.
        if (event) {
          event.stopPropagation();
        }

        scope.view.first = scope.getPerPage(scope.view.amount) * page;

        var ds = scope.datasource();
        scope.updateView(ds);
        // directly go to top
        ang.callAfter(function() {
          element.find('.pageTop').scrollintoview();
        });
      };

      scope.$afterViewUpdate = function(viewData, afterFunc) {
        app.startPerfTimer('cfnGrid afterViewUpdate');
        if (scope.view.amount > 0) {
          scope.view.currentPage =
            1 +
            Math.floor(scope.view.first / scope.getPerPage(scope.view.amount));
          scope.view.pageCount = Math.ceil(
            scope.view.amount / scope.getPerPage(scope.view.amount)
          );
        } else {
          scope.view.currentPage = 1;
          scope.view.pageCount = 0;
        }
        scope.view.pages = [];
        var p;
        for (p = 0; p < scope.view.pageCount; p++) {
          scope.view.pages.push({
            number: p + 1,
            selected: scope.view.currentPage == p + 1
          });
        }

        scope.viewDataHash = {};
        $.each(viewData, function(k, v) {
          scope.viewDataHash[v.id] = v;
        });

        scope.viewData = viewData;

        /* why would you remove the selection in other view?
       $.each(scope.selected,function(k,v){
       if(v)
       v.$cfngrid_selected=false; // remove selection in other view
       var dat = scope.viewDataHash[k];
       if(dat){
       dat.$cfngrid_selected=true;
       scope.selected[k] = dat;
       }
       }); */

        scope.updateSelectionView();

        app.stopPerfTimer('cfnGrid afterViewUpdate');

        if (scope.afterViewChange()) scope.afterViewChange()();

        if (afterFunc) afterFunc();
      };

      serviceInstance.deactivateSortOnce = function() {
        isSortingDeactivatedOnce = true;
      };

      serviceInstance.updatePaginationView = function(sortedModel) {
        var viewData = [];

        var num = 0;

        scope.view.amount = sortedModel.length;

        if (scope.view.first > scope.view.amount)
          // reset view position if outside of view
          scope.view.first = 0;

        var i;
        for (i = scope.view.first; i < scope.view.amount; i++) {
          var modelRow = sortedModel[i];
          num++;
          if (num > scope.getPerPage(scope.view.amount)) break;
          viewData.push(modelRow);
        }
        app.stopPerfTimer('cfnGrid model add');

        return viewData;
      };
      return serviceInstance;
    };

    return service;
  }
]);
